import {MetricDistance} from "../../../../../misc/MetricDistance";
import {ImperialDistance} from "../../../../../misc/ImperialDistance";
import {inches} from "../const";
import {UnitSystem} from "../../../../../api/Projects";
import {HardwareGroupWithContent} from "../../../../../api/Hardware";


export function drawingUnits(input: ImperialDistance | MetricDistance): number {
    if(input instanceof ImperialDistance) {
        return input.inchesFlt() * inches;
    }

    return ImperialDistance.fromUniversal(input.universalValue()).inchesFlt() * inches;
}

export function parseUnits(sys: UnitSystem, value: string) {
    if(sys === "metric") {
        return MetricDistance.parse(value);
    } else {
        return ImperialDistance.parse(value);
    }
}

export function parseDrawingUnits(value: string, sys: UnitSystem) {
    const v = parseUnits(sys, value);
    return drawingUnits(v);
}

// parse a stored prep-config value into drawing units. The value's unit comes from the
// string, not the project: an "mm" suffix is metric, anything else is imperial (same rule
// as misc/dim ParseDimensionErr on the backend).
export function parsePrepDrawingUnits(value: string) {
    const sys: UnitSystem = value.trim().toLowerCase().endsWith("mm") ? "metric" : "imperial";
    return parseDrawingUnits(value, sys);
}

// read a named prep-config entry (e.g. "overCutDoor", "underCutDoor", "underCutFrame")
// from the hardware group and convert its dimension to drawing units. Returns null
// when the group has no such entry or it carries no value, so callers keep their
// default. The cuts live in prepConfigJson alongside the hinge custom offsets.
export function prepConfigDrawingUnits(hardware: HardwareGroupWithContent | null, name: string): number | null {
    const entry = hardware?.prepConfigJson?.find(p => p.name === name);
    if(!entry || !entry.value) return null;
    return parsePrepDrawingUnits(entry.value);
}
